import React from 'react';
import { useDrop } from 'react-dnd';

import styles from './style.less';

import { DraggableItemType } from '../../constants/dragItemType';

export function DroppableAnswer(props) {
  const { answer, disabled, href } = props;

  const [index, ...options] = decodeURI(href.slice(1)).split('|').filter(s => !!s);
  let answerElement = answer && answer.answerElements && answer.answerElements.find(ae => ae.index == index);
  let text = answerElement && answerElement.value;
  const isCorrect = text && options.some(o => o === `*${text}*`);
  const spanClass = disabled ? (isCorrect ? styles.correctDND : styles.incorrectDND) : '';

  if (!text) {
    text = '\u00A0';
  }

  const [{ isOver }, drop] = disabled ? [{isOver:false}, null] : useDrop({
    accept: DraggableItemType.ANSWER,
    drop: (item, monitor) => {
      const value = monitor.getItem().value;
      const correct = options.some(o => o === `*${value}*`);
      if (props.onChange) props.onChange({
        index,
        value,
        correct
      });
    },
    collect: monitor => ({
      isOver: !!monitor.isOver(),
    }),
  });

  return (
    <span className={styles.outerSpan} >
      <span ref={drop}
        className={`${styles.target} ${spanClass}`}
        style={{
          opacity: isOver ? 0.5 : 1,
          backgroundColor: isOver ? 'yellow' : 'white'
        }}
      >
        {text}
      </span>
    </span>
  );
}

export default DroppableAnswer;
